import { render, staticRenderFns } from "./WsAnalyticsCard.vue?vue&type=template&id=36486799&"
import script from "./WsAnalyticsCard.vue?vue&type=script&lang=js&"
export * from "./WsAnalyticsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports